<template>
  <div class="account-page register-page">
    <!-- bg -->
    <div class="bg" ref="videoBg">
      <img :src="poster" alt="" />
      <div class="mask"></div>
    </div>
    <!-- header -->
    <div class="header">
      <el-button
        type="primary"
        size="small"
        @click="gotoIndex"
        v-text="'< 返回首页'"
      ></el-button>
    </div>
    <!-- form wrapper -->
    <div class="form-wrapper">
      <h1 class="form-header">用户注册</h1>
      <choose-account label="我想注册下以下账号:"></choose-account>
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.min.css";
import { gotoIndex } from "@/libs/tools";
import ChooseAccount from "@/components/ChooseAccountType";

export default {
  components: {
    "choose-account": ChooseAccount
  },
  data() {
    return {};
  },
  computed: {
    poster() {
      return `${this.baseUrl}media/trade_cover.png`;
    }
  },
  methods: {
    gotoIndex() {
      gotoIndex();
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/pages/account.scss";
</style>
